import { render, staticRenderFns } from "./OpenQuestion.vue?vue&type=template&id=137730e7&scoped=true"
import script from "./OpenQuestion.vue?vue&type=script&lang=js"
export * from "./OpenQuestion.vue?vue&type=script&lang=js"
import style0 from "./OpenQuestion.vue?vue&type=style&index=0&id=137730e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137730e7",
  null
  
)

export default component.exports